<template>
  <div class="list-group-item" :class="{ active: selectedItemId === item.id, 'bg-warning': selectedItemId === item.id }">
    <span v-handle class="fa fa-exchange fa-rotate-90 handle mr-2"></span>
    <slot></slot>
  </div>
</template>
 
<script>
import { ElementMixin, HandleDirective } from 'vue-slicksort';
 
export default {
	props: {
    item: {
    	type: Object
    },
    selectedItemId: {
      type: Number
    }
	},
  // data () {
  //   return {
  //     canalId: this.$parent.canalId
  //   }
  // },
  mixins: [ElementMixin],
  directives: { handle: HandleDirective },
  methods: {
  }

}
</script>
<style scoped>
.handle {
    display: inline-block;
    float: left;
    width: 18px;
    height: 18px;
    /*background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M0 7.5v5h50v-5H0zm0 15v5h50v-5H0zm0 15v5h50v-5H0z" color="%23000"/></svg>');*/
    background-size: contain;
    background-repeat: no-repeat;
    opacity: .80;
    cursor: row-resize;
}
</style>